import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const RedButton = withStyles(theme => ({
    contained: {
        color: '#ffffff',
        backgroundColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        },
    },
    text: {
        color: theme.palette.error.main,
        '&:hover': {
            backgroundColor: 'rgba(237, 28, 36, 0.08)'
        },
    },
    outlined: {
        color: theme.palette.error.main,
        border: '1px solid',
        borderColor: theme.palette.error.main,
        '&:hover': {
            backgroundColor: 'rgba(237, 28, 36, 0.08)',
            borderColor: theme.palette.error.main,
        },
    }
}))(Button);

export default RedButton;
